import * as e from "react";
import { forwardRef as t } from "react";
const a = t(function(r, o) {
  return /* @__PURE__ */ e.createElement(
    "svg",
    {
      fill: "none",
      ref: o,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...r
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        clipRule: "evenodd",
        d: "M11 8H9V16H11V8ZM15 8H13V16H15V8Z",
        fill: "currentColor",
        fillRule: "evenodd"
      }
    )
  );
});
export {
  a as Break
};
